import { render, staticRenderFns } from "./copy-exam-modal.vue?vue&type=template&id=734146d6"
import script from "./copy-exam-modal.vue?vue&type=script&lang=ts"
export * from "./copy-exam-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports